import { render, staticRenderFns } from "./homePage3.vue?vue&type=template&id=50c59b5b&scoped=true"
import script from "./homePage3.vue?vue&type=script&lang=js"
export * from "./homePage3.vue?vue&type=script&lang=js"
import style0 from "./homePage3.vue?vue&type=style&index=0&id=50c59b5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c59b5b",
  null
  
)

export default component.exports